<template>
      <div class="app-container1">

              <div id="base" class=""> 
      <!-- Unnamed (Rectangle) -->
      <div id="u3794" class="ax_default box_1">
        <div id="u3794_div" class=""></div>
        <div id="u3794_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>
        <div class="app-container2">
        <!--
         <div class="filter-container">
                    <el-button type="success"  @click="handleSave" icon="el-icon-plus" size="mini" plain>{{$t('commons.batchsave')}}</el-button>
          </div>
       -->
        <el-table
              
                :data="list"
                element-loading-text="Loading"
                border
                fit
                highlight-current-row
                stripe @selection-change="handleSelectionChange">
      
           <el-table-column prop="id" :label="$t('input.performance.num')" align="center">
            </el-table-column>
             <el-table-column prop="parametername" :label="$t('input.performance.name')" align="center">
            </el-table-column>
            <el-table-column :label="$t('input.performance.value')" align="center">
              <template slot-scope="scope">
                    <template v-if="scope.row.edit">
                        <el-input v-model="scope.row.parametervalue" maxlength="80" :show-word-limit="true" size="small" clearable :placeholder="$t('commons.pleaseInput')"/>
                    </template>
                    <span v-else>{{ scope.row.parametervalue }}</span>
                </template>
            </el-table-column>
           <el-table-column prop="operation" :label="$t('commons.actions')" align="center">
                <template slot-scope="scope">
                    <template v-if="scope.row.edit">
                        <div class="iori-buttons">
                            <a class="iori-button" @click="updatePerformance(scope.row)" :title="$t('commons.save')"><i class="el-icon-circle-check"></i></a>
                            <a class="iori-button"  @click="cancelTagEdit(scope.row)" :title="$t('commons.cancel')"><i class="el-icon-circle-close"></i></a>
                        </div>
                    </template>
                    <template v-else>
                        <div class="iori-buttons">
                            <a class="iori-button" @click="editTag(scope.row)" :title="$t('commons.edit')"><i class="el-icon-edit-outline"></i></a>
                           
                        </div>
                    </template>
                </template>
            </el-table-column>
           
        </el-table>
        <pagination v-show="total>0" :total="total" :page.sync="listQuery.current" :limit.sync="listQuery.rowCount"
                    @pagination="getTagPage"/>

         </div>
       </div>
    </div>
</template>

<script>
  import {
        getTagList,
        getTagTypeList
    
    } from '@/api/iori/tag'
           import {
      getParameterList,
      updateParameter
    
    } from '@/api/business/energy/performance'
    import{
        getProjectList
    }from '@/api/business/base/tenant/project'
    import {      
        getPositionTree
    } from '@/api/business/base/tenant/device'
    import Pagination from '@/components/Pagination'
  
    import { envInfo } from '@/constants/envInfo'
    import store from '@/store/index'
    import {listToTree} from '@/utils/tree'
    import TreeSelect from '@riophae/vue-treeselect';
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    export default {
        name: 'TagManager',
        components: {Pagination, TreeSelect},
        data() {
           return{
               addDialog: false,
               createLoading: false,
               tagTypeList:[],
               list: null,
               total: 0,
               listLoading: true,
               projectList:[],
               positionList:[],
               rootPath: envInfo.bgApp.tagPath,
               multipleSelection:[],
               listQuery: {
                   current: 1,
                   rowCount: 10,
                   selectMonth: null,
                   positionId : null,
                   projectId: null,
               },
               // 日期范围查询组件
               pickerOpts: {
                   // 默认日期
                   pickerData: null,
                   // 快捷选项
                   shortcuts: null,
               },
               form:{
                   selectMonth: null,
                   positionId : null,
                   projectId: null,
                   rowid: null,
             
               },
             
           }
        },
         created() {
            //this.getTagPage();
           // this.getTagTypeList();
            //this.getProjectList();
            this.getQueryPage();
        },
        methods: {
              selectPosition(node){
                this.listQuery.positionId = node.positionId;
                //alert(this.listQuery.positionId);
               },
                
           getQueryPage() {
                this.listLoading = true;
                
                getParameterList().then(response => {
                    
                    this.list = response.rows;
                
                    this.total = response.total;
                    this.listLoading = false;
                })
            },
            updatePerformance(row) {
                this.listLoading = true;
               

                updateParameter(row).then(() => {
                    this.$message({type: 'success', message: this.$t('message.operationSuccess')});
                    row.edit = false;
                    this.listLoading = false;
                    this.setTag(row);
                }).catch(() => {
                    this.listLoading = false;
                })
            },
            editTag(row) {
                this.setTag(row);
                row.edit = true;
            },
            cancelTagEdit(row) {
                this.resetTag(row);
                row.edit = false;
            },
           
             setTag(row) {
                row.ordParametervalue = row.parametervalue;
              //  alert(row.ordPrice);
               
            },
             resetTag(row) {
                 // alert(row.ordPrice);
                row.parametervalue = row.ordParametervalue;
            
            },
           
        }
    }
</script>
<style scoped>

   @import "../../../../../assets/common/performance/css/month/styles.css";
   @import "../../../../../assets/common/consumption/css/styles.css";
   @import "../../../../../assets/common/rp_page.css";


.app-container1 {
  margin: 0px;
  padding: 20px;
  background-color: rgb(243, 247, 255);
  border-radius: 5px;
  min-height: calc(100vh - 50px);

}
.app-container2 {
   border-width:0px;
   position:relative;
   left:250px;
   top:100px;
   width: 1170px;
   background:inherit;

}
</style>